import React from 'react';
import { Input } from '../ui/input';
import useLookup from '../../utils/useLookup';
import { productLinesService, warehousesService } from '../../services/productionService';
import { STATUS_OPTIONS } from '../../constants/listOptions';

export const PRODUCT_FILTER_DEFAULTS = {
    code: '',
    item: '',
    productLineId: '',
    status: '',
    warehouseId: '',
};

export function toProductFilterParams(applied) {
    return {
        code: applied.code || undefined,
        item: applied.item || undefined,
        product_line_id: applied.productLineId || undefined,
        status: applied.status || undefined,
        warehouse_id: applied.warehouseId || undefined,
    };
}

const selectClass =
    'h-10 w-full rounded-lg border border-gray-300 bg-white px-3 text-sm focus:outline-none focus:ring-2 focus:ring-primary-500';
const labelClass = 'block text-sm font-medium text-gray-700 mb-1';

/** Campos de filtro dos relatórios por produto, para o conteúdo do FilterDrawer. `filters` vem de useReportFilters. */
function ProductFilterFields({ filters }) {
    const productLines = useLookup(() => productLinesService.list({ per_page: 1000 }));
    const warehouses = useLookup(() => warehousesService.list({ per_page: 1000 }));

    return (
        <>
            <div>
                <label className={labelClass}>Código Item</label>
                <Input value={filters.draft.code} onChange={(e) => filters.set('code', e.target.value)} />
            </div>
            <div>
                <label className={labelClass}>Nome Item</label>
                <Input value={filters.draft.item} onChange={(e) => filters.set('item', e.target.value)} />
            </div>
            <div>
                <label className={labelClass}>Linha</label>
                <select
                    className={selectClass}
                    value={filters.draft.productLineId}
                    onChange={(e) => filters.set('productLineId', e.target.value)}
                >
                    <option value="">Todas</option>
                    {productLines.map((l) => (
                        <option key={l.id} value={l.id}>{l.name}</option>
                    ))}
                </select>
            </div>
            <div>
                <label className={labelClass}>Status</label>
                <select
                    className={selectClass}
                    value={filters.draft.status}
                    onChange={(e) => filters.set('status', e.target.value)}
                >
                    <option value="">Todos</option>
                    {STATUS_OPTIONS.map((s) => (
                        <option key={s.value} value={s.value}>{s.label}</option>
                    ))}
                </select>
            </div>
            <div>
                <label className={labelClass}>Depósito padrão</label>
                <select
                    className={selectClass}
                    value={filters.draft.warehouseId}
                    onChange={(e) => filters.set('warehouseId', e.target.value)}
                >
                    <option value="">Todos</option>
                    {warehouses.map((w) => (
                        <option key={w.id} value={w.id}>{w.name}</option>
                    ))}
                </select>
            </div>
        </>
    );
}

export default ProductFilterFields;
